import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { scrollToTop } from 'utils/Link';

const CaseDemo = (props) => {
  return (
    <div className="case-demo">
      <div className="content">
        <Link onClick={scrollToTop} to={props.link}>
          <div className="img" style={{
            backgroundImage: `url(${props.image})`
          }} />
        </Link>
        <div className="text">
          <h3 className="title">{props.name}</h3>
          <div className="intro">
            {props.intro}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseDemo;

CaseDemo.propTypes = {
  client: PropTypes.string,
  id: PropTypes.any,
  image: PropTypes.string,
  intro: PropTypes.string,
  link: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.array,
  during: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/pages/CasePage/components/CaseDemo.js